import { createSvgRoot } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-root'
import { getSvgDefs } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-defs'
import {
  OVERLAY_COLORS,
  OVERLAY_OPACITY,
  VIEW_MODES
} from '@aytm/app/stats/page/question-views/hm/components/chart/lib/constants'
import { drawContoursByClusters } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/contours'

export const drawOverlayByClusters = (container, options) => {
  const { id, answer, image, scale, width, height } = options
  const imageHeight = image?.original?.height

  const viewMode = VIEW_MODES.OVERLAYCLUSTERS

  if (!answer?.heatmap?.contours_by_polygons || !answer?.heatmap?.levels_by_polygons) return null

  const svg = createSvgRoot(container, { id, viewMode, width, height, scale })

  const defs = svg.append('defs')
  defs.html(
    getSvgDefs(id, viewMode, {
      imagePath: image.original.path,
      imageWidth: width,
      imageHeight: height
    })
  )

  // the blend filter is emitted per view, so it is addressed by the view rather than by name
  const group = svg
    .append('g')
    .attr('id', `svg-${viewMode}-${id}-group`)
    .attr('filter', `url(#filter-${viewMode}-${id})`)

  group.append('rect').attr('fill', 'none').attr('width', width).attr('height', height)

  drawContoursByClusters(group, {
    id,
    contours: answer.heatmap.contours_by_polygons,
    levels: answer.heatmap.levels_by_polygons,
    imageHeight,
    colors: OVERLAY_COLORS,
    opacityValues: OVERLAY_OPACITY
  })

  return null
}
